import { convertToExportedView } from '@estee/elc-service';
import { HELPFUL_LINKS } from '@estee/elc-service-view-names';
import { IHelpfulLinksContainer } from './HelpfulLinks';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IHelpfulLinksContainer>(
    () => import('./HelpfulLinks'),
    HELPFUL_LINKS
);
